import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IconDefinition, faAddressBook } from '@fortawesome/pro-duotone-svg-icons';
import { Store } from '@ngxs/store';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import _ from 'lodash';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { BasicBrickComponent } from 'src/app/components/bricks/basic-brick-component';
import { SamwebWindowComponent } from 'src/app/components/utility/samweb-window/samweb-window.component';
import { ShortcutDescription } from 'src/app/samwebDescription/samweb/shortcuts/shortcutDescription';
import { DirectoryBrowserRemoveEditEntry } from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-behaviour/directory-editing/directory-editing-behaviour.actions';
import {
   DirectoryEditingBehaviourState,
   DirectoryEntryEditInfo,
} from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-behaviour/directory-editing/directory-editing-behaviour.state';
import { HOTKEYS_DISABLED } from 'src/app/store/samwin/shortcut-behaviour/hotkeys-disabled';
import { RemoveWindow } from 'src/app/store/utility/samweb-window/samweb-window.actions';
import { WindowType, WindowTypes } from 'src/app/store/utility/samweb-window/samweb-window.state';

@Component({
   selector: 'samweb-directory-editing-dialog',
   templateUrl: './directory-editing-dialog.component.html',
   styleUrls: ['./directory-editing-dialog.component.scss'],
})
export class DirectoryEditingDialogComponent extends BasicBrickComponent implements OnInit {
   private destroy$ = new Subject();

   @ViewChild(SamwebWindowComponent) window: SamwebWindowComponent;

   @ViewChild('closeTooltipDirective')
   public closeTooltipDirective: TooltipDirective;

   @Input()
   public id: number;

   public directoryEditInfo$: Observable<DirectoryEntryEditInfo>;

   public type: WindowType = WindowTypes.Directory;

   public icon: IconDefinition = faAddressBook;

   public title = '';

   public areEditableEntriesChanged$: Observable<boolean>;

   constructor(private store: Store) {
      super();
   }

   public keyActions: ShortcutDescription[] = [
      {
         shortcutKey: HOTKEYS_DISABLED,
         action: () => {
            return true;
         },
      },
   ];

   ngOnInit() {
      this.title =
         this.id < 0
            ? 'brick.brick_definitions.directory_browser.add_contact_details.title'
            : 'brick.brick_definitions.directory_browser.edit_contact_details.title';

      this.directoryEditInfo$ = this.store.select(DirectoryEditingBehaviourState.getEditedDirectoryInfoById).pipe(map((getEntry) => getEntry(this.id)));

      this.areEditableEntriesChanged$ = this.store
         .select(DirectoryEditingBehaviourState.areEditableEntriesChanged)
         .pipe(map((areEntriesChanged) => areEntriesChanged(this.id)));
   }

   closeWindow() {
      this.store.dispatch(new DirectoryBrowserRemoveEditEntry(this.id));
      this.store.dispatch(new RemoveWindow(this.type, this.id.toString()));
   }

   onCancel(areEditableEntriesChanged: boolean) {
      if (areEditableEntriesChanged) {
         if (!_.isNil(this.window.closePopupControl)) {
            this.closeTooltipDirective.show(this.window.closePopupControl.nativeElement);
            return;
         }
         return;
      }
      this.closeWindow();
   }

   onCloseConfirm() {
      this.closeWindow();
   }

   onCloseCancel() {
      this.closeTooltipDirective.hide();
   }
}
